import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { ICastCrewDTO, CastCrewDTO } from './cast.crew.dto';
import { IReleaseDTO, ReleaseDTO } from './release.dto';
import { ISubmissionDTO, SubmissionDTO } from './submission.dto';
import { IUserDTO, UserDTO } from './user.dto';

export interface ISubmissionCastCrewDTO extends IBaseEntityDTO {
  first_name: string;
  last_name: string;
  character_name: string;
  email_address: string;
  castCrew: ICastCrewDTO | undefined;
  other_cast_crew: string;
  order: number;
  user: IUserDTO | undefined;
  submission: ISubmissionDTO | undefined;
  release: IReleaseDTO | undefined;
}

export class SubmissionCastCrewDTO extends BaseEntityDTO implements ISubmissionCastCrewDTO {
  first_name: string;
  last_name: string;
  character_name: string;
  email_address: string;
  castCrew: ICastCrewDTO | undefined;
  other_cast_crew: string;
  order: number;
  user: IUserDTO | undefined;
  submission: ISubmissionDTO | undefined;
  release: IReleaseDTO | undefined;

  constructor(data?: Partial<ISubmissionCastCrewDTO>) {
    super(data);
    this.first_name = data?.first_name || '';
    this.last_name = data?.last_name || '';
    this.character_name = data?.character_name || '';
    this.email_address = data?.email_address || '';
    this.castCrew = data?.castCrew ? new CastCrewDTO(data?.castCrew) : undefined;
    this.other_cast_crew = data?.other_cast_crew || '';
    this.user = data?.user ? new UserDTO(data?.user) : undefined;
    this.order = data?.order || 0;
    this.submission = data?.submission ? new SubmissionDTO(data?.submission) : undefined;
    this.release = data?.release ? new ReleaseDTO(data?.release) : undefined;
  }
}
